import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const page = css`
    padding: 0;
  `;

  const formLabel = css`
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: ${theme.colors.navy["1"]};
    margin-bottom: 4px;
  `;

  const deleteButton = css`
    cursor: pointer;
    color: ${theme.colors.gray["4"]};
    &:hover {
      color: ${theme.colors.red};
    }
  `;

  const editLink = css`
    color: ${theme.colors.teal["1"]};
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
  `;

  return {
    page,
    formLabel,
    editLink,
  };
};

export default useStyles;
